












import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Menu from '@/components/Menu.vue';
import { AdminInfoModel } from '@/models/AdminInfo';

const module = namespace('ToolStore');

@Component({
  components: {
    Menu,
  },
})
export default class Header extends Vue {
    @module.State private adminInfo!: AdminInfoModel;
}
